// Matches SERVICE_REQUEST_DELIVERY_QUERY_LIMITS.defaultPageSize in the backend.
export const SERVICE_DELIVERY_DEFAULT_PAGE_SIZE = 50;

export const SERVICE_DELIVERY_DEDUPING_INTERVAL_MS = 30_000;

// Matches the delivery query validator in the backend.
export const SERVICE_DELIVERY_MIN_SEARCH_LENGTH = 2;
export const SERVICE_DELIVERY_MAX_SEARCH_LENGTH = 100;
export const SERVICE_DELIVERY_MAX_SELECTED_IDS = 500;
export const SERVICE_DELIVERY_MAX_SORT_FIELDS = 3;
